import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Typography, Button, Container } from '@mui/material';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm" sx={{ textAlign: 'center', py: 10 }}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            エラーが発生しました
          </Typography>
          <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
            予期しないエラーが発生しました。ページを再読み込みしてください。
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            ページを再読み込み
          </Button>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
